module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAANlJREFUeAHFlI0NgjAQha/GAXACcROcgBFgBSdwBTewjuAGjsAG7QawQX1nSlIrrbT48yUvlwL3UdpQom9hjGmQ3qSjuHf0CEeoUDrkSmnUSCWE2PgzZFpKhHu4cRyvIw9WKKV3eUA6zEaH+oJC0CJN4GUHSE9T91b0BuGA4Q7RyBHSIkvoyTXKBSlslgktW1uHqZuxNXyATzs7wxKpEInZ5gnpeadZEtyQWUI07ymBnDX8rTD2yTfE0KeEWDuJImmBkHewdv7zufBpo1+u2lNDmXT6nFPqf9wBZjKz4BSDasAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PPT.png
// module id = sFXE
// module chunks = 1